import classNames from "classnames";

import {
  GUIDE_ONBOARDING_STEPS,
  getGuideOnboardingStepIndex,
} from "./steps";

const BuilderOnboardingShell = ({
  currentStep,
  rental,
  allowStepNavigation = false,
  children,
  onStepChange,
  onFinish,
  hideActions = false,
  actionBusy = false,
}) => {
  const currentIndex = Math.max(getGuideOnboardingStepIndex(currentStep.id), 0);
  const isLastStep = currentIndex === GUIDE_ONBOARDING_STEPS.length - 1;
  const groups = GUIDE_ONBOARDING_STEPS.reduce((result, step, index) => {
    if (!result[step.group]) result[step.group] = [];
    result[step.group].push({ ...step, index });
    return result;
  }, {});

  const goBack = () => {
    if (currentIndex > 0) onStepChange(GUIDE_ONBOARDING_STEPS[currentIndex - 1]);
  };

  const goForward = (extra = {}) => {
    if (isLastStep) {
      onFinish();
      return;
    }
    onStepChange(GUIDE_ONBOARDING_STEPS[currentIndex + 1], extra);
  };

  return (
    <div className="guide-onboarding-shell is-full-flow">
      <aside className="guide-onboarding-checklist" aria-label="Setup progress">
        <div className="guide-onboarding-progress-copy">
          <p className="guide-onboarding-eyebrow">Your guide</p>
          <strong>
            Step {currentIndex + 1} of {GUIDE_ONBOARDING_STEPS.length}
          </strong>
        </div>

        {Object.entries(groups).map(([group, steps]) => (
          <div className="guide-onboarding-step-group" key={group}>
            <p>{group}</p>
            <ol>
              {steps.map((step) => (
                <li
                  key={step.id}
                  className={classNames({
                    "is-current": step.id === currentStep.id,
                    "is-complete": step.index < currentIndex,
                  })}
                >
                  <button
                    type="button"
                    disabled={!allowStepNavigation && step.index > currentIndex}
                    onClick={() => onStepChange(step)}
                    aria-current={step.id === currentStep.id ? "step" : undefined}
                  >
                    <span aria-hidden="true">
                      {step.index < currentIndex ? "✓" : step.index + 1}
                    </span>
                    {step.label}
                  </button>
                </li>
              ))}
            </ol>
          </div>
        ))}
      </aside>

      <main className="guide-onboarding-workspace">
        <header className="guide-onboarding-workspace-header">
          <div>
            <p className="guide-onboarding-eyebrow">
              {currentStep.group} · Step {currentIndex + 1}
            </p>
            <h2>{currentStep.label}</h2>
          </div>
          {currentStep.id !== "property" && rental && (
            <div
              className="guide-onboarding-property-context"
              aria-label="Saved property"
            >
              <span>Property</span>
              <strong>{rental.name || rental.pms_id || "Your property"}</strong>
              {rental.address && <small>{rental.address}</small>}
            </div>
          )}
        </header>

        <div className="guide-onboarding-workspace-body">{children}</div>

        {!hideActions && (
          <footer className="guide-onboarding-workspace-actions">
            <button
              type="button"
              className="uk-button hms-btn hms-white-btn"
              onClick={goBack}
              disabled={currentIndex === 0 || actionBusy}
            >
              Back
            </button>
            <div>
              {currentStep.optional && !isLastStep && (
                <button
                  type="button"
                  className="uk-button uk-button-text guide-onboarding-skip"
                  onClick={() =>
                    goForward({ skipped_step: currentStep.id })
                  }
                  disabled={actionBusy}
                >
                  Skip for now
                </button>
              )}
              <button
                type="button"
                className="uk-button hms-btn hms-red-btn"
                onClick={() => goForward()}
                disabled={actionBusy}
              >
                {isLastStep ? "Finish" : "Continue"}
              </button>
            </div>
          </footer>
        )}
      </main>
    </div>
  );
};

export default BuilderOnboardingShell;
